<template>
    <div class="col margin-bottom-50 thanks">
        <div class="row">
            <div class="thanks_content clearfix w-100">
                <div class="title">
                    <h3>{{ site.name }}</h3>
                </div>
                <section class="col-sm-12 q">
                    <section class="vraag w100 clearfix">
                        <p>{{ genderTranslation }} {{ contact.last_name }},</p>

                        <p>{{ $t('default.MessageReceived')}}</p>

                        <p><strong>{{ $t('default.YouFilledIn')}}</strong></p>

                        <table width="100%" cellpadding="2" cellspacing="2" border="0">
                            <tr v-if="block.themes.length > 1">
                                <td>{{ $t('default.Theme') }}</td>
                                <td>{{ themeTranslation }} </td>
                            </tr>

                             <tr>
                                <td>{{ $t('default.Question') }}</td>
                                <td>{{ contact.description_consumer }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('default.Firstname') }}</td>
                                <td>{{ contact.first_name }} </td>
                            </tr>

                            <tr>
                                <td>{{ $t('default.Lastname') }}</td>
                                <td>{{ contact.last_name }}</td>
                            </tr>

                            <tr v-if="block.show_year_of_birth">
                                <td>{{ $t('default.Yearofbirth') }}</td>
                                <td>{{ contact.year_of_birth }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('default.Email') }}</td>
                                <td>{{ contact.email }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('default.Phone') }}</td>
                                <td>{{ contact.phone }}</td>
                            </tr>

                            <tr v-if="block.expanded">
                                <td>{{ $t('default.Address') }}</td>
                                <td>{{ contact.street}}</td>
                            </tr>

                            <tr v-if="block.expanded">
                                <td>{{ $t('default.Zipcode') }}</td>
                                <td>{{ contact.zip_code }}</td>
                            </tr>

                            <tr v-if="block.expanded">
                                <td>{{ $t('default.City') }}</td>
                                <td>{{ contact.city }}</td>
                            </tr>
                        </table>
                    </section>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import Block from "@/mixins/Block.js"
    import GenderTranslation from '@/mixins/GenderTranslation.js'

    export default {
        props: ['contact'],
        mixins: [Block, GenderTranslation],
        computed: {
            themeTranslation() {
                const theme = this.block.themes.find(theme => theme.id == Number(this.contact.theme_id));

                return theme.name;
            }
        }
    }
</script>